<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS접수모델` }}</h3>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReady"
                            @cell-clicked="onCellClicked" 
                            @first-data-rendered="onFirstDataRendered"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- 고장증상 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">고장증상</h3>
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="모델">
                                <el-input v-model="form.modelNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="제조번호">
                                <el-input v-model="form.serialNo" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                </div>
                <el-table
                    :data="tableTroubleData"
                    style="width: 100%">
                    <el-table-column
                    prop="breakGb"
                    label="증상구분"
                    width="200">
                    </el-table-column>
                    <el-table-column
                    prop="breakHst"
                    label="고장증상"
                    width="400">
                    </el-table-column>
                    <el-table-column
                    prop="breakDtl"
                    label="상세증상"
                    width="500">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 고장증상 e. -->

        <!-- 고객요구사항 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                    <h3 class="ico_table_name">고객요구사항</h3>
                    <el-input  type="textarea" 
                        :autosize="{ minRows: 4, maxRows: 6}"
                        v-model="form.callMemo" :readonly="readonlyMemo"></el-input>
                </div>
            </div>
        </div>
        <!-- 고객요구사항 e. -->

        <!-- 특이사항 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                    <h3 class="ico_table_name">특이사항</h3>
                    <el-input  type="textarea" 
                        :autosize="{ minRows: 4, maxRows: 6}"
                        v-model="form.visitMemo" :readonly="readonlyMemo"></el-input>
                </div>
            </div>
        </div>
        <!-- 특이사항 e. -->

        <!-- 하단 필터 input s. -->
        <div class="table-area">
            <div class="table-a">
                <el-form>
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="접수센터">
                                <el-input  type="input"
                                v-model="form.createAsAgentNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="접수자">
                                <el-input  type="input"
                                v-model="form.creatorNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="처리센터">
                                <el-input  type="input"
                                v-model="form.repairAsAgentNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="처리기사">
                                <el-input  type="input"
                                v-model="form.repairNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 하단 필터 input -->

        <div class="table-a">
            <el-row :gutter="6">
                <el-col>
                    <el-button type="info" icon="el-icon-document" v-show="showEngineerAllocatable" @click="changeRepairSchedule">
                        처리기사변경
                    </el-button>
                    <el-button type="info" icon="el-icon-document" v-show="showEngineerAllocatable" @click="updateRepair">
                        저장
                    </el-button>
                </el-col>
                <el-col>
                    <el-button type="info" icon="el-icon-document" v-show="showMemoUpdate" @click="updateMemo">
                        수정
                    </el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
/**
 * lodash
 */
import _ from 'lodash';
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import ModelActor from '@/components/LucomsModal/ModelActor.vue';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';

export default {
    components: {AgGridVue, DhxCalendar},
    props: ['receptionParam'],
    data() {
        return {
            tableTroubleData: [{
                breakGb: '',
                breakHst: '',
                breakDtl: '',
            },],
            form: { //테스트 폼 데이터
                asId: '',
                modelNm: '',  //모델
                serialNo: '', //제조번호
                callMemo: '', //고객요구사항 textarea
                visitMemo: '',   //특이사항 textarea
                createAsAgentNm: '',    //접수센터
                createAsAgentId: '',    //접수센터 ID
                creatorNm: '',    //접수자
                areaAgent: '',
                repairAsAgentId: '',    //접수센터 ID
                repairAsAgentNm: '',    //처리센터
                repairNm: '',    //처리기사
                repairId: ''
            },
            data: [],
            showEngineerAllocatable: false, /** 저장버튼 표시여부 */
            showMemoUpdate: false, /** 수정버튼 표시여부 */
            readonlyMemo: true, /** 메모수정여부 */
            addr1: '',
            addr2: '',
            selDetailIdx: -1, /** 선택된 AS접수모델 index */
            tabCacheLoadData: {},  /** tab을 클릭시 셋팅된 데이타 : AS접수모델 클릭시 재로딩하면 시간이 걸려서 캐싱하여서 로딩시키기 위해 */

            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                select: SelectCellRenderer,
                radio: RadioCellRenderer,
                checkbox: CheckboxCellRenderer,
            },
            //AG-GRID OPTION [END]
        }
    },
    mounted() {
        console.log('RecpHst receptionParam : ', this.receptionParam)
        // if(this.receptionParam.callAsProcessSel1List){
        //     this.data = this.receptionParam.callAsProcessSel1List
        //     console.log('ProcsHst callAsProcessSel1List : ', this.data)
        // }
        this.$emit("loadTab", {"tabNm":"1", "index": 0})
    },
    methods: {
        onFirstDataRendered(params) {
            const initIdx = 0;
            params.api.forEachNode((node) => {
                //node.setSelected(node.rowIndex === initIdx);
                if(node.rowIndex === initIdx) {
                    const {model, prodNo} = node.data;
                    this.form = _.merge(this.form, {model, prodNo});
                    node.setSelected(true);
                }
            });
        },
        onReady(params) {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.createColumnDefs();

            //set data
            // const updateData = (data) => params.api.setRowData(data);
            // this.data = [{model: 'L2200DMW-5GSTK', recptTp: '01', yn: 'N', prodNo: '903LMB700061'}, {model: 'L2200DMW-5GSTK+', recptTp: '02', yn: 'Y', prodNo: '907LMB160120'}];
            // updateData(this.data);

        },
        createColumnDefs() {
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    hide: true,
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:110,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:110,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'대표모델',
                    field:'standardModelNm', 
                    width:110,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:160,
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:110,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width:90,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'보증만료일',
                    field:'guaranteeEndDt', 
                    width:130,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'구입년월',
                    field:'purchaseDt', 
                    width:130,
                    cellRenderer: 'datePicker',
                    cellRendererParams: {
                        // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                        type: 'month',
                        format: 'yyyy-MM',  //date format
                        valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                        disable: true,
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'접수유형/세부유형',
                    field:'recptTp', 
                    width:220,
                    cellRenderer: 'select',
                    cellRendererParams: {
                        options : [{key: '01', value: '유상수리'}, {key: '02', value: '무상수리'}],
                        detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                        detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'유/무상',
                    field:'payYn', 
                    width:180,
                    cellRenderer: 'radio',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selDetailIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }  
                },
            ];
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;

            this.selDetailIdx = idx;
            
            // 로딩속도 개선 : 직접호출시 속도가 늦음. 이미 로딩된 캐싱을 이용해서 2번 방법 사용.
            // 1. 직접호출
            //this.$emit("loadTab", {"tabNm":"1", "index": idx, "asDetailId": params.data.asDetailId, "asProcessId": params.data.asProcessId })
            
            // 2. 캐싱 사용
            this.tabCacheLoadData.asDetailId = params.data.asDetailId;
            this.tabCacheLoadData.asProcessId = params.data.asProcessId;
            this.changeRecpHstInfo(this.tabCacheLoadData, idx);
            this.gridApi.redrawRows({ rowNodes: params });

            if(field === 'modelNm') {
              this.openModelSpec(params.data);
            }
            
            // this.data = this.data.map((x, i) => {
            //     if(idx === i) {
            //         if(x.chk === 'Y') {
            //             return x;
            //         } else {
            //             x.chk = x?.chk !== 'Y' ? 'Y' : 'N';
            //         }
            //     } else {
            //         if(x.chk === 'Y') {
            //             x.chk = x?.chk !== 'N' ? 'N' : 'Y';
            //         } else {
            //             return x;
            //         }
            //     }
            //     return x;
            // });

            // const {model, prodNo} = this.data.filter(x => x.chk === 'Y')?.[0];
            
            // this.form = _.merge(this.form, {model, prodNo});
        },
        changeRecpHstInfo(param, index){
            console.log('PecptHst changeRecpHstInfo start param : ', index, param)
            this.tabCacheLoadData = param;
            
            const vAsDetailId = param.asDetailId || '';
            if(vAsDetailId === '') return false;

            this.form.asId = param.callAsDetail[index].asId || ''
            this.form.modelNm = param.callAsDetail[index].modelNm || ''
            this.form.serialNo = param.callAsDetail[index].serialNo || ''

            const vSqObj = param.callAsMstSelList[0]
            const vAstatus = vSqObj ? vSqObj.asStatus : ''
            console.log('vAstatus: ', vAstatus)

            if(vSqObj){
                this.form.callMemo = vSqObj.callMemo  || '' // 고객요구사항
                this.form.visitMemo = vSqObj.visitMemo  || '' // 특이사항
                this.form.areaAgent = vSqObj.allocationArea
            }

            // AS미처리리스트 : 214
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===214)
            let GrantAllocation = false // 수리기사변경
            if(auth && auth.length > 0){
                GrantAllocation = auth[0].grantExtend2 === 'Y' ? true : false
            }

            // 저장버튼 표시처리
            //this.showEngineerAllocatable = (GrantAllocation && vAstatus === 'Receipt') ? true : false
            this.showEngineerAllocatable = GrantAllocation;

                        
            // 수정버튼 표시처리
            this.showMemoUpdate = false
            this.readonlyMemo = !this.showMemoUpdate
            if(vAstatus === 'Receipt'){
                this.showMemoUpdate = true
                this.readonlyMemo = !this.showMemoUpdate
            }

            if(param.callAsProcessMstSelList && param.callAsProcessMstSelList.length > index){
                this.form.createAsAgentNm = param.callAsProcessMstSelList[index].createAsAgentNm || '' // 접수센터
                this.form.createAsAgentId = param.callAsProcessMstSelList[index].createAsAgentId || '' // 접수센터 ID
                
                this.form.creatorNm = param.callAsProcessMstSelList[index].creatorNm || '' // 접수자
                this.form.repairAsAgentNm = param.callAsProcessMstSelList[index].repairAsAgentNm || '' // 처리센터
                this.form.repairAsAgentId = param.callAsProcessMstSelList[index].repairAsAgentId || '' // 처리센터 ID
                this.form.repairNm = param.callAsProcessMstSelList[index].repairNm || '' // 처리기사
                this.form.repairId = param.callAsProcessMstSelList[index].repairId || '' // 처리기사 ID
            }
            
            // 고장증상
            this.tableTroubleData = param.callAsCat
                .filter(x=>x.asDetailId==vAsDetailId)
                .map(y => { 
                    let arrCat = y.asCatFullNm.split('>');
                    if(arrCat){
                        if(arrCat.length >= 1){
                            y.breakGb = arrCat[0] ;
                        }
                        if(arrCat.length >= 2){
                            y.breakHst = arrCat[1] ;
                        }
                    }
                    y.breakDtl = y.description;
                    return y;
                });

            const vCustObj = param.callCustSelItemList[index]

            if(vCustObj){
                this.addr1 = vCustObj.addr1
                this.addr2 = vCustObj.addr2
            }
            
        },
        changeRepairSchedule(){
            /** 처리기사 팝업 오픈 */
            const vm = this
            const vSrchObj = this.$parent.$parent.form
            const vForm = {
                            addr1 : vSrchObj.addr1 || '',
                            addr2 : vSrchObj.addr2 || '',
                            areaAgent : (vm.form.areaAgent ? vm.form.areaAgent : vSrchObj.areaAgent) || '', /** 지역 ID*/
                            asAgentId : (vm.form.asAgentId ? vm.form.asAgentId : vSrchObj.asAgentId) || '' , /** 센터ID */
                            repairId : (vm.form.userId ? vm.form.userId : vSrchObj.userId) || '' ,
                        }
        console.log('openModelAtcor vSrchObj: ', vSrchObj, vForm)
            this.$modal.open({
                component: ModelActor,
                parent: vm,
                width: 1000,
                props: {
                    data: vForm,
                },
                events: {
                    close(data) {
                        console.log('openModelAtcor close', data);
                        vm.form.areaAgent = data.areaAgent /** 지역 ID */
                        vm.form.repairAsAgentId = data.asAgentId /** 처리센터 ID */
                        vm.form.repairAsAgentNm = data.asAgentNm /** 처리센터 */
                        vm.form.repairId = data.userId /**처리기사 */
                        vm.form.repairNm = data.userNm /**처리기사 */
                        
                        if(data.selField === ''){
                            vm.form.requestVisitDt = undefined
                            vm.form.requestVistHh = ''
                            vm.form.requestVistMm = ''
                        } else {
                            if(data.selField === 'toMorn' || data.selField === 'toAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(1, 'day').format('YYYY-MM-DD') /** 익일 */
                            } else if(data.selField === 'dotMorn' || data.selField === 'dotAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(2, 'day').format('YYYY-MM-DD') /** 익익일 */
                            } else {
                                vm.form.requestVisitDt = vm.$moment().format('YYYY-MM-DD') /** 당일 */
                            }

                            // 일시 셋팅
                            vm.form.requestVistMm = '0' /** 요청일시 분 */
                            if(data.selField === 'after' || data.selField === 'toAfter' || data.selField === 'dotAfter') {
                                vm.form.requestVistHh = '13'  /** 요청일시 시간 : 오후 */
                            } else {
                                vm.form.requestVistHh = '9'  /** 요청일시 시간 : 오전 */
                            }
                        }
                        
                    },
                }
            });
             
        },
        updateRepair(){
            /** 처리기사 수정 */
            const vSaveform = {
                asId : this.form.asId,
                userId : this.form.repairId
            }

            this.$swal({
                type: 'warning',
                text: `처리기사를 변경하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')
                    this.$http.put("/api/asMng/call/updateRepair", vSaveform)
                        .then(response => {
                            
                            if(response.data === 'OK'){
                                this.$swal({ type: 'success', text: '처리기사가 재배정되었습니다.' });
                            }else {
                                this.$swal({ type: 'success', text: response.data });
                            }
                            
                        }).catch((e) => {
                            console.log('pass response aaaa2:', e)
                            //console.logger('error ::::', e);
                            // console.error(e);
                            // this.$swal({ type: 'success', text: '처리기사수정에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish')
                        });
                }
            });
        },
        updateMemo(){
            // 메모수정
            // USP_AS_UPT_MEMO
            
            if(this.form.callMemo === '' && this.form.visitMemo === ''){
                this.$swal({type: 'warning', text: '고객요구사항 혹은 특이사항을 입력해주십시오.'});
                return false
            }
            
            const vSaveform = {
                asId : this.form.asId,
                callMemo : this.form.callMemo,
                visitMemo : this.form.visitMemo
            }

            this.$swal({
                type: 'warning',
                text: `메모(고객요구사항, 특이사항)를 수정하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')
                    this.$http.put("/api/asMng/call/updateMemo", vSaveform)
                        .then(response => {
                            this.$swal({ type: 'success', text: '메모가 수정되었습니다.' });
                            
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '메모수정에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish')
                        });
                }
            });

        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
        openModelSpec(param) {

          const vForm = {
            modelGroup: param.modelGroup,
            modelCd : param.modelNm
          };

          this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});
        }
    }
}
</script>